import { Component, OnDestroy, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import { Observable, Subscription, timer } from 'rxjs';

import { SLIP_WIDTH } from '~/constant/ui.constant';
import { translationHelper } from '~/helpers/translation.helper';
import { uiHelper } from '~/helpers/ui.helper';
import { SlipModel } from '~/legacy/ts/categories/categories';
import { CoreService, CustomerUser } from '~/legacy/ts/services/core.service';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { environment } from '@env/environment';

declare let JsBarcode: any;

declare let $;
declare let SetLanguage: any;
declare let betaluxBr;

declare let BettingSlip_CountDown: any;
declare let TranslateOnlyText;

@Component({
    selector: 'bettingSlip',
    templateUrl: './betting.slip.html',
})
export class BettingSlipView implements OnInit, OnDestroy {
    public styles = {
        main: {
            height: this.tournamentsService.Page_Window_Height - 75 + 'px',
            'font-size': '12px',
            'margin-bottom': '0px',
            'margin-top': '0px',
        },
        fixtureArea: {
            width: this.tournamentsService.Page_Window_Width - SLIP_WIDTH - 34 + 'px',
            height: this.tournamentsService.Page_Window_Height - 75 + 'px',
        },
    };

    public SlipmodelList: Observable<SlipModel[]>;
    public BettingSlip_Countdown = 5;
    public timer_subscription: Subscription;

    /// Refresh Slip
    public refreshtimer_subscription: Subscription;
    public error_oddrefresherror = false;
    /// Refresh Slip
    public rbscounterValue = 10;
    public currentScore;
    public matchDate;
    public matchTimeDate;
    public sportName;
    public Clicked_Button_Submit_Bet = false;
    public slipType = 1;
    public inverted: string;
    public taxamount = '5';
    public amount = '5';
    public sitedirection: string;
    public stakeInput = 5;
    public openBetsCashoutValue = 0;
    public openBetsSlipId = 0;
    public rbsSetIntervalClear;
    public liveData;

    public subClientCO: Subscription;

    public openBets_subClientCO: Subscription;
    public init: boolean;
    private timer;
    private refreshtimer;

    private timeropenbets;

    private currentslip_subscription: Subscription;
    private live_subscription: Subscription;
    private oddClickReceived_subscription: Subscription;

    private isWidgetInitialized = false;
    public brWidgetVisibility = false;

    @ViewChild('brWidget', { static: false })
    set childComponent(element: any) {
        if (element && typeof betaluxBr !== 'undefined') {
            if (!this.isWidgetInitialized) {
                const selectedLang = this._translate.LANGCODE;
                betaluxBr.init('betrecommend', 'widgetContainer', {
                    apiKey: environment.bRSmallWidgetApiKey,
                    language: selectedLang,
                });
                betaluxBr.get('betrecommend').setNoExternalLink(true);

                betaluxBr.get('betrecommend').setMarkets(this.tournamentsService.slipCurrents.map(x => x.OddId1));
                const theme = 'light';
                betaluxBr.get('betrecommend').setThemeMode(theme);
                betaluxBr.get('betrecommend').setLanguage(selectedLang);
                this.isWidgetInitialized = true;

                betaluxBr.offAll('addMarketToSlip');
                betaluxBr.on('betrecommend', 'addMarketToSlip', this.addMarketToSlip.bind(this));
                betaluxBr.on('betrecommend', 'widgetVisibility', this.setBrWidgetVisibility.bind(this));
            }
        } else {
            // betaluxBr.remove('betrecommend', 'widgetContainer');
            console.log('remove betrecommend');
            if (typeof betaluxBr !== 'undefined') {
                betaluxBr.offAll('betrecommend', 'addMarketToSlip');
                betaluxBr.offAll('betrecommend', 'widgetVisibility');
            }
            this.isWidgetInitialized = false;
        }
    }

    constructor(
        public tournamentsService: TournamentsService,
        public coreService: CoreService,
        public _uiHelper: uiHelper,
        private _translate: translationHelper,
        private changeDetection: ChangeDetectorRef,
    ) {
        if (this.currentslip_subscription == undefined) {
            this.currentslip_subscription = this.tournamentsService.CurrentSlipReceived.subscribe(s => {
                if (this.tournamentsService.slipCurrents != undefined) {
                    if (this.tournamentsService.slipCurrents.length > this.tournamentsService.max_event_count) {
                        this.tournamentsService.messageType = 'errorMessage';
                        this.tournamentsService.message = this._translate.getT('maxeventwarning');
                    } else if (this.tournamentsService.message == this._translate.getT('maxeventwarning')) {
                        this.tournamentsService.messageType = '';
                    }
                }

                if (this.tournamentsService.tax > 0) {
                    this.changeTaxAmount(null);
                }
                this.changeDetection.detectChanges();
            });
        }

        if (this.oddClickReceived_subscription == undefined) {
            this.oddClickReceived_subscription = this.tournamentsService.oddClickReceived.subscribe(s => {
                this.refreshSlipTimer();
            });
        }
        console.warn(
            'betting slip',
            this.tournamentsService.CalculatorValue,
            typeof this.tournamentsService.CalculatorValue,
        );
    }

    addMarketToSlip(market) {
        let newOdd = {
            OddId: parseInt(market.marketId),
            HomeTeam: market.homeTeamName,
            AwayTeam: market.awayTeamName,
            MatchId: market.eventId,
            GroupName: market.marketTypeText + '|',
            OddTypeId: market.marketType,
            OddValue: market.marketValue,
            OutCome: market.marketOutcome,
            SpecialBetValue: market.specialMarketValue,
            EventDate: market.eventDate,
            ShortOddType: market.marketType,
        };
        let newEvent = {
            HomeTeam: market.homeTeamName,
            AwayTeam: market.awayTeamName,
            MatchId: market.eventId,
            EventDate: market.eventDate,
            SportNameOriginal: market.sportName,
            WithBr: true,
        };

        this.tournamentsService.addOddNew(newOdd, $('input[name="__RequestVerificationToken"]').val(), '0', newEvent);
    }
    public ngOnInit() {
        SetLanguage('', '');
        // this.sitedirection = sitedirection;
        if (this.init) {
            return;
        }

        this.tournamentsService.getCurrentSlip();
        // this.inverted = css;
        this.init = true;

        // this.SlipmodelList.subscribe(s => {

        // });
        // Kupon Güncelleme
        this.refreshSlipTimer();

        this.tournamentsService.isCashOutActive = false;

        this.liveData = this._uiHelper.liveFilteredData;
        if (this.live_subscription == undefined)
            this.live_subscription = this._uiHelper.liveFilteredDataListener.subscribe(x => {
                this.liveData = x;
            });
    }

    public ObCashoutModalExit() {
        $('#openBetsCashoutModal').modal('hide');
    }

    public setBrWidgetVisibility(data) {
        if (data === 'show') {
            this.brWidgetVisibility = true;
        } else {
            this.brWidgetVisibility = false;
        }
    }

    public OpenBetsCashotPay(CashoutValue, SlipId) {
        this.openBetsCashoutValue = CashoutValue;
        this.openBetsSlipId = SlipId;
        $('#openBetsCashoutModal')
            .modal({
                allowMultiple: true,
                closable: false,
            })
            .modal('show');
    }

    public ExitCreditVoucherModalOb() {
        $('#cashoutdetail_creditvoucheropenbets').modal('hide');
    }

    public SubmitNewBetOb() {
        $('#cashoutdetail_creditvoucheropenbets').modal('hide');
        this.tournamentsService.router.navigate(['/LiveBets']);
    }

    public ObCashoutValueOk() {
        $('#openBetsCashoutModal').modal('hide');
        this.tournamentsService.getsendCashOutOpenBets_Terminal(
            this.openBetsCashoutValue,
            this.openBetsSlipId,
            $('input[name="__RequestVerificationToken"]').val(),
        );
        // $('#openBetsCashoutModal').modal('hide');
    }

    public showOpenBets() {
        if (this.coreService.showOpenBetsVisible == 1) {
            this.coreService.showOpenBetsVisible = 0;

            this.tournamentsService.cleanOpenBets_Timer();

            return '';
        } else if (this.coreService.showOpenBetsVisible == 0) {
            // this.tournamentsService.getOpenBets();
            this.coreService.showOpenBetsVisible = 1;

            this.tournamentsService.openBets_Timer();
            return '';
        }
    }

    public getOpenBetDetail(SlipId) {
        this.tournamentsService.cleanOpenBets_Timer();

        this.tournamentsService.SlipCashOutSlipNumber = SlipId;
        this.tournamentsService.router.navigate(['/SlipDetail']);
    }

    public removeSlip(e) {
        this.tournamentsService.removeOdd(e);

        if (this.tournamentsService.slipCurrents && this.tournamentsService.slipCurrents.length === 1) {
            this.tournamentsService.BettingSlip_Menu_SlipType = 0;
        }
    }

    public refreshSlipTimer() {
        if (this.refreshtimer_subscription != undefined) {
            this.refreshtimer_subscription.unsubscribe();
            this.refreshtimer_subscription = null;
            this.refreshtimer = null;
        }

        this.refreshtimer = timer(1000, 10000);
        this.refreshtimer_subscription = this.refreshtimer.subscribe(t => {
            this.error_oddrefresherror = false;
            if (this.tournamentsService.slipCurrents.length > 0) {
                this.tournamentsService.refreshCurrentSlip();
                const visibilityindex = this.tournamentsService.slipCurrents.findIndex(v => {
                    return v.Visibility == 'hidden';
                });
                if (visibilityindex > -1) {
                    this.error_oddrefresherror = true;
                }
            }
        });
    }

    public ngOnDestroy() {
        //console.warn('destroy');
        if (this.refreshtimer_subscription != undefined) {
            this.refreshtimer_subscription.unsubscribe();
        }
        if (this.currentslip_subscription != undefined) {
            this.currentslip_subscription.unsubscribe();
        }
        if (this.live_subscription != undefined) {
            this.live_subscription.unsubscribe();
        }
        if (this.oddClickReceived_subscription != undefined) {
            this.oddClickReceived_subscription.unsubscribe();
        }
    }

    public changeAmount(event: any) {
        if (event != null) {
            if (event.target.name == 'systemslipitem') {
                if (event.target.checked) {
                    event.target.value = 1;
                } else {
                    event.target.value = 0;
                }
            }
        }

        if (this.tournamentsService.CalculatorValue != undefined) {
            if (Number(this.tournamentsService.CalculatorValue) < 2) {
                this.tournamentsService.messageType = 'errorMessage';
                this.tournamentsService.message = this._translate.getT('minslipamountwarning');
            } else if (this.tournamentsService.message == this._translate.getT('minslipamountwarning')) {
                this.tournamentsService.messageType = '';
            }
        }

        this.tournamentsService.changeSlipAmount(this.amount, this.tournamentsService.BettingSlip_Menu_SlipType);
    }

    public changeTaxAmount(e) {
        this.amount = (
            (Number(this.tournamentsService.CalculatorValue) * 100) /
            (100 + this.tournamentsService.tax)
        ).toFixed(6);
        this.changeAmount(e);
    }

    public diffarencetax() {}

    public changeSlipType(e) {
        this.tournamentsService.BettingSlip_Menu_SlipType = e;

        this.tournamentsService.changeSlipAmount(this.amount, this.tournamentsService.BettingSlip_Menu_SlipType);
        this.tournamentsService.isClicked = [];
        this.tournamentsService.SystemModalButtonValueArray = [];
        this.tournamentsService.SystemModalButtonValue = this._translate.getT('System_Combinations');

        // this.slipType = e;
        // this.tournamentsService.changeSlipAmount(this.amount, this.slipType);
        // LoadCheckboxes();
    }

    public BettingSlip_Click_SubmitBet() {
        // Min Amount Check
        if (this.tournamentsService.CalculatorValue != undefined) {
            if (Number(this.tournamentsService.CalculatorValue) < 2) {
                return;
            }
        }

        // Min Event Count
        if (this.tournamentsService.slipCurrents != undefined) {
            if (this.tournamentsService.slipCurrents.length == 0) {
                return;
            }
        }

        // Balance Check
        // console.log(Number(this.coreService.customerUser.CurrentBalance), Number(this.tournamentsService.CalculatorValue));
        if (this.coreService.customerUser != undefined) {
            if (
                Number(this.coreService.customerUser.CurrentBalance) < Number(this.tournamentsService.CalculatorValue)
            ) {
                this.tournamentsService.messageType = 'errorMessage';
                this.tournamentsService.message = TranslateOnlyText('errorcode6');
                return;
            }
        }
        if (
            this.tournamentsService.SystemModalButtonValue === this._translate.getT('System_Combinations') &&
            this.tournamentsService.BettingSlip_Menu_SlipType === 2
        ) {
            this.tournamentsService.messageType = 'errorSystemMessage';

            this.tournamentsService.message = TranslateOnlyText('errorSystemMessage');
        } else if (Number(this.tournamentsService.slipAmount.AmountPerBet) < 0.05) {
            this.tournamentsService.messageType = 'errorMessage';

            this.tournamentsService.message = TranslateOnlyText('Amount_Per_Bet_Error');
        } else {
            this.tournamentsService.messageType = '';
            this.tournamentsService.message = '';
            SetLanguage('', '');
            this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet = true;
            this._uiHelper.AllscreenButtonActive(false);
        }

        // this.RsbCounter();
    }

    public RestoreBettingSlipFunc() {
        this.tournamentsService.rsbCounterVisible = 0;
        this.tournamentsService.rbscounterValue = 11;
        clearInterval(this.tournamentsService.rbsSetIntervalClear);
        // setTimeout(() => this.tournamentsService.doSetTimeoutGreen(), 100);
        // this.tournamentsService.rbsSetIntervalClearGreen = setInterval(() => this.tournamentsService.doSetTimeoutGreen(), 100);
        this.tournamentsService.RestoreSlip_Terminal_Bet($('input[name="__RequestVerificationToken"]').val());
    }

    public BettingSlip_Click_Modify() {
        this._uiHelper.AllscreenButtonActive(true);
        SetLanguage('', '');
        this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet = false;
    }

    public BettingSlip_Click_Confirm() {
        this.changeTaxAmount(null);

        SetLanguage('', '');
        // this.Clicked_Button_Submit_Bet = true;

        if (this.tournamentsService.CalculatorValue >= 2000 && this.coreService.CustomerCardIsActive == 0) {
            this.tournamentsService.Message_Modal_Header = this._translate.getT('INFO');
            this.tournamentsService.Message_Modal_Desc = this._translate.getT('Please_Insert_Your_Customer_Card');

            $('#Message_Modal').modal('show');
            return;
        }

        this.tournamentsService.isCashOutActive = true;
        $('#BettingSlip_CountDown_Dimmer')
            .dimmer({ opacity: '1' })
            .dimmer('show');

        if (this.timer_subscription != undefined) {
            this.timer_subscription.unsubscribe();
        }

        this.timer = timer(1000, 1000);

        console.log('slips : ', this.tournamentsService.slipCurrents);
        console.log('slipevent : ', this.tournamentsService.slipCurrents.length);
        console.log('system : ', this.tournamentsService.systemSlips);

        const values = $('button[name="systemslipitem"]')
            .map(function() {
                return this.value;
            })
            .get();

        console.log('values : ', values);

        // Combi Slip Type 1 ve maç sayısı 2'den fazla ise direk
        if (this.tournamentsService.slipType == '1' && this.tournamentsService.slipCurrents.length > 2) {
            this.tournamentsService.submitBet(Number(this.amount));
            // Bekleme
            clearInterval(this.timer);
            $('#BettingSlip_CountDown_Dimmer').dimmer('hide');
            this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet = false;
        }
        // Hepsi pre match (BetType=0) ise bekleme
        else if (
            this.tournamentsService.slipCurrents.length ==
            this.tournamentsService.slipCurrents.filter(s => s.BetType == 0).length
        ) {
            // Bekleme
            this.tournamentsService.submitBet(Number(this.amount));
            clearInterval(this.timer);
            $('#BettingSlip_CountDown_Dimmer').dimmer('hide');
            this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet = false;
        } else if (
            this.tournamentsService.slipType == '2' &&
            values.length > 2 &&
            values[0] == '0' &&
            values[1] == '0'
        ) {
            this.tournamentsService.submitBet(Number(this.amount));
            //  //Slip Type 2 ve maç sayısı 2 den fazla ise ve system 1 ve 2 seçilmediyse
            clearInterval(this.timer);
            $('#BettingSlip_CountDown_Dimmer').dimmer('hide');
            this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet = false;
        } else {
            this.timer_subscription = this.timer.subscribe(t => {
                if (this.BettingSlip_Countdown == 5) {
                    this.tournamentsService.submitBet(Number(this.amount));
                }
                this.BettingSlip_Countdown--;
                if (this.BettingSlip_Countdown == 0) {
                    SetLanguage('', '');
                    clearInterval(this.timer);
                    this.timer = null;

                    this.timer_subscription.unsubscribe();

                    $('#BettingSlip_CountDown_Dimmer').dimmer('hide');
                    this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet = false;

                    // Submit Bet
                }
            });
        }

        this.BettingSlip_Countdown = 5;
    }

    public BettingSlip_Click_Confirm_Temp() {
        if (
            this.tournamentsService.SystemModalButtonValue === this._translate.getT('System_Combinations') &&
            this.tournamentsService.BettingSlip_Menu_SlipType === 2
        ) {
            this.tournamentsService.messageType = 'errorSystemMessage';

            this.tournamentsService.message = TranslateOnlyText('errorSystemMessage');
        } else {
            SetLanguage('', '');
            // this.Clicked_Button_Submit_Bet = true;

            if (this.tournamentsService.CalculatorValue >= 2000 && this.coreService.CustomerCardIsActive == 0) {
                this.tournamentsService.Message_Modal_Header = this._translate.getT('INFO');
                this.tournamentsService.Message_Modal_Desc = this._translate.getT('Please_Insert_Your_Customer_Card');

                $('#Message_Modal').modal('show');
                return;
            }

            this.tournamentsService.isCashOutActive = true;

            $('#BettingSlip_CountDown_Dimmer')
                .dimmer({ opacity: '1' })
                .dimmer('show');

            if (this.timer_subscription != undefined) {
                this.timer_subscription.unsubscribe();
            }

            this.timer = timer(1000, 1000);

            console.log('slips : ', this.tournamentsService.slipCurrents);
            console.log('slipevent : ', this.tournamentsService.slipCurrents.length);
            console.log('system : ', this.tournamentsService.systemSlips);

            const values = $('button[name="systemslipitem"]')
                .map(function() {
                    return this.value;
                })
                .get();

            console.log('values : ', values);

            // Combi Slip Type 1 ve maç sayısı 2'den fazla ise direk
            if (this.tournamentsService.slipType == '1' && this.tournamentsService.slipCurrents.length > 2) {
                this.tournamentsService.submitBetTemp(Number(this.amount));
                // Bekleme
                clearInterval(this.timer);
                $('#BettingSlip_CountDown_Dimmer').dimmer('hide');
                this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet = false;
            }
            // Hepsi pre match (BetType=0) ise bekleme
            else if (
                this.tournamentsService.slipCurrents.length ==
                this.tournamentsService.slipCurrents.filter(s => s.BetType == 0).length
            ) {
                // Bekleme
                this.tournamentsService.submitBetTemp(Number(this.amount));
                clearInterval(this.timer);
                $('#BettingSlip_CountDown_Dimmer').dimmer('hide');
                this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet = false;
            } else if (
                this.tournamentsService.slipType == '2' &&
                values.length > 2 &&
                values[0] == '0' &&
                values[1] == '0'
            ) {
                this.tournamentsService.submitBetTemp(Number(this.amount));
                //  //Slip Type 2 ve maç sayısı 2 den fazla ise ve system 1 ve 2 seçilmediyse
                clearInterval(this.timer);
                $('#BettingSlip_CountDown_Dimmer').dimmer('hide');
                this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet = false;
            } else {
                this.timer_subscription = this.timer.subscribe(t => {
                    if (this.BettingSlip_Countdown == 5) {
                        this.tournamentsService.submitBetTemp(Number(this.amount));
                    }
                    this.BettingSlip_Countdown--;
                    if (this.BettingSlip_Countdown == 0) {
                        this.tournamentsService.submitBetTemp(Number(this.amount));
                        SetLanguage('', '');
                        clearInterval(this.timer);
                        this.timer = null;

                        this.timer_subscription.unsubscribe();

                        $('#BettingSlip_CountDown_Dimmer').dimmer('hide');
                        this.tournamentsService.BettingSlip_Clicked_Button_Submit_Bet = false;

                        // Submit Bet
                    }
                });
            }

            this.BettingSlip_Countdown = 5;
            this._uiHelper.AllscreenButtonActive(false);
            // this.clearall();
        }
    }

    public banko_btn_style(e) {
        if (e.Banko == true) {
            return 'active';
        } else {
            return '';
        }
    }

    public changeSelectedSlipCurrent(e) {
        const enable = e.Enable;
        const banko = !e.Banko;
        const oddId = e.OddId1;

        this.tournamentsService.changeSelectedSlipCurrent(
            enable,
            banko,
            oddId,
            $('input[name="__RequestVerificationToken"]').val(),
        );
        this.tournamentsService.isClicked = [];
        this.tournamentsService.SystemModalButtonValueArray = [];
        this.tournamentsService.SystemModalButtonValue = this._translate.getT('System_Combinations');
        // LoadCheckboxes();
    }

    public factorial(e) {
        if (e == 1 || e == 0) {
            return 1;
        } else {
            return e * this.factorial(e - 1);
        }
    }

    public combination(r) {
        const n = this.tournamentsService.systemSlips.length;
        return this.factorial(n) / (this.factorial(n - r) * this.factorial(r));
    }

    public clearall() {
        this.tournamentsService.clearSlip();
        // this.tournamentsService.controlBet(this.amount);
    }

    public focuslost() {}

    public clickOdd(oddId) {
        SetLanguage('', '');
        this.tournamentsService.addOdd(oddId, $('input[name="__RequestVerificationToken"]').val());
    }

    public BettingSlip_StakeIncrease() {
        this.stakeInput = this.stakeInput + 1;
        this.tournamentsService.CalculatorValue = this.tournamentsService.CalculatorValue + 1;

        this.changeTaxAmount(null);
    }

    public BettingSlip_StakeDecrease() {
        if (this.tournamentsService.CalculatorValue > 0) {
            this.stakeInput = this.stakeInput - 1;
            this.tournamentsService.CalculatorValue = this.tournamentsService.CalculatorValue - 1;

            this.changeTaxAmount(null);
        }
    }

    public Open_BettinSlip_System_Modal() {
        SetLanguage('', '');
        // $('#BettingSlip_System_Modal').modal('show');
        this.tournamentsService.isClicked = [];
        this.tournamentsService.SystemModalButtonValueArray = [];
        this.tournamentsService.SystemModalButtonValue = this._translate.getT('System_Combinations');
        this.tournamentsService.getSystemSlips();

        $('#BettingSlip_System_Modal')
            .modal({
                detachable: false,
                // onHidden: function () {
                //    //$('#BettingSlip_System_Modal').modal('destroy');

                //    //setTimeout(function () {
                //    //    //$('#BettingSlip_System_Modal').modal('is active');
                //    //    $('#BettingSlip_System_Modal').remove();
                //    //}, 300);

                //    //this.tournamentsService.obj_bettingslip_system_modal = null;
                // }
            })
            .modal('show');

        // if (this.tournamentsService.obj_bettingslip_system_modal == undefined) {
        //    this.tournamentsService.obj_bettingslip_system_modal = GetModal;
        //    this.tournamentsService.obj_bettingslip_system_modal.modal('show');
        // }
        // else {
        //    this.tournamentsService.obj_bettingslip_system_modal.modal('show');
    }

    public Open_BettinSlip_Calculator_Modal() {
        SetLanguage('', '');
        // $('.ui.active.dimmer').dimmer('hide');
        // $('.dimmed.dimmable >.ui.animating.dimmer').dimmer('hide');
        // $('.dimmed.dimmable>.ui.visible.dimmer').dimmer('hide');
        $('#BettingSlip_Calculator_Modal')
            .modal({
                detachable: false,
            })
            .modal('show');
    }

    public changeAmount_From_Calculator(e) {
        this.stakeInput = parseFloat(e);
        this.changeTaxAmount(null);
    }

    public Balance_Button_Open_Modal() {
        // $('#BettingSlip_Balance_Modal').modal('show');

        $('#BettingSlip_Balance_Modal')
            .modal({
                allowMultiple: true,
            })
            .modal('show');
    }

    public getMatchtime(e) {
        let index = -1;
        // console.log("Live Data :",this.liveData);
        if (this.liveData != undefined) {
            index = this.liveData.findIndex(v => {
                return v.MatchId == e.eEvents[0].MatchId;
            });
        }

        if (index != -1) {
            this.currentScore = this.liveData.find(v => v.MatchId == e.eEvents[0].MatchId).Score;

            return this._translate.getT('LIVE') + '-' + this._translate.getT('SCORE') + ':' + this.currentScore;
        } else {
            // var _matchDate = this.tournamentsService.terminalAllUpcomingList.find(v => v.MatchId == e.eEvents[0].MatchId);
            // if (_matchDate != undefined)
            //  this.matchDate = _matchDate.MatchGroupDate;

            // var _matchTimeDate = this.tournamentsService.terminalAllUpcomingList.find(v => v.MatchId == e.eEvents[0].MatchId);
            // if (_matchTimeDate != undefined)
            //  this.matchTimeDate = _matchTimeDate.MatchTime;

            return e.EventDate;
        }
    }

    public getSportName(e) {
        let index = -1;

        if (this.tournamentsService._liveFixtureList != undefined) {
            index = this.tournamentsService._liveFixtureList.findIndex(v => {
                return v.EventId == e.eEvents[0].MatchId;
            });
        }

        if (index != -1) {
            this.sportName = this.tournamentsService._liveFixtureList.find(
                v => v.EventId == e.eEvents[0].MatchId,
            ).SportNameOriginal;

            return this.sportName;
        } else {
            this.sportName = '';

            const _upcomingMatch = this.tournamentsService.terminalAllUpcomingList.find(
                v => v.MatchId == e.eEvents[0].MatchId,
            );

            if (_upcomingMatch != undefined) {
                this.sportName = _upcomingMatch.SportName;
            }

            return this.sportName;
        }
    }

    public ConvertFloat(e) {
        return parseFloat(e);
    }

    public dataFormatter(e) {
        if (e == undefined) return;

        if (e.split(' ')[0] == undefined) return e;

        if (e.split(' ')[1] == undefined) return e;

        const _year = new Date().getFullYear();
        return new Date(
            _year,
            e.split(' ')[0].split('-')[1] - 1,
            e.split(' ')[0].split('-')[0],
            e.split(' ')[1].split(':')[0],
            e.split(' ')[1].split(':')[1],
        );
    }

    getSubmitButtonText() {
        return this.tournamentsService.SystemModalButtonValueArray &&
            this.tournamentsService.SystemModalButtonValueArray.length > 0 &&
            this.tournamentsService.isMultiWay
            ? this._translate.getT('isMultiWayButton')
            : this._translate.getT('SubmitBet');
    }
    getCashoutValue(slip: any) {
        try {
            if (this._uiHelper.terminalConfig.IsJacktimeActive === true) {
                let cashoutSlip = this.tournamentsService.cashOutValueList_Terminal.filter(
                    i => i.SlipId == slip.SlipId,
                );
                return (slip.CashoutValueJacktime === 0
                    ? slip.CashoutValueJacktime
                    : slip.CashoutValueJacktime - 0.01
                ).toFixed(2);
            } else {
                return slip.CashoutValue.toFixed(2);
            }
        } catch (e) {}
    }
}
